module.exports = __webpack_public_path__ + "img/index05.4f06b26c.jpg";